import {clearDocumentField, currentUser, getDocumentField, updateDocument} from '@/services/FirestoreService';

/**
 * The signed-in user's saved map preferences — filters, layers, drawn boundary, export field selections. The only
 * module that writes them, so the embedded comp picker turns writes off with one call (ADR 0023). Reads are never
 * gated: whether the picker should read a preference is the caller's call, not a persistence rule.
 */

// Shareable maps keep user docs in their own project, under `users`
const usersCollection = () => (process.env.VUE_APP_FLAVOR === 'external' ? 'users' : 'beyondMaps-users');

let writesEnabled = true;

/** Set before the first preference is written. */
export const setProfileWritesEnabled = (enabled: boolean): void => {
  writesEnabled = enabled;
};

export const profileWritesEnabled = (): boolean => writesEnabled;

const uid = (): string | null => currentUser()?.uid ?? null;

/** Resolves `undefined` when the document or the field is absent — only a real Firestore error rejects. */
export const readPreference = async <T = unknown>(field: string): Promise<T | undefined> => {
  const id = uid();
  if (!id) return undefined;
  return getDocumentField(usersCollection(), id, field);
};

export const writePreferences = async (fields: Record<string, unknown>): Promise<void> => {
  const id = uid();
  if (!writesEnabled || !id) return;
  await updateDocument(usersCollection(), id, fields);
};

export const clearPreference = async (field: string): Promise<void> => {
  const id = uid();
  if (!writesEnabled || !id) return;
  await clearDocumentField(usersCollection(), id, field);
};
